
import { VDivider } from "vuetify/lib";

export default VDivider.extend({});
